import BackendClient from "../BackendClient";

export const getPromotions = () => {
  let axios = BackendClient.getInstance();
  axios({
    url: '/api/casino/promotions',
  }).catch(e => {
    console.log(`[CATCHED ERROR] => ${e}`);
  });
};